import { render, staticRenderFns } from "./InvestmentReports.vue?vue&type=template&id=65beebfd"
import script from "./InvestmentReports.vue?vue&type=script&lang=js"
export * from "./InvestmentReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports